import * as auth from '../_redux/authRedux';
import { Avatar, TextField, Link, Typography } from '@material-ui/core';
import { Button, Alert } from 'rsuite';
import { connect } from 'react-redux';
import { cuotitasUrl } from '../../../services/abstract';
import { injectIntl } from 'react-intl';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import loginService from '../../../services/login';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

export function Login (props) {
    const history = useHistory();
    // State

    const [isLoading, setIsLoading] = useState(false);
    const [email, setEmail] = useState('');

    // Events

    const toLogin = () => {
        history.goBack();
    };

    const recover = async (event) => {
        try {
            event.preventDefault();
            setIsLoading(true);

            await loginService.forgot({
                idPlatform: 5,
                email,
                metadata: {
                    url: `${cuotitasUrl}/users/recover`,
                }
            });

            Alert.success('Por favor revisar la casilla de mail ingresada y seguir los pasos para recuperar la contraseña.', 5000);
        }
        catch (error) {
            if (error.response?.data?.extra?.key === 'user_blocked') {
                return Alert.warning('Su usuario se ha bloqueado.', 7000);
            }
            if (error.response?.data?.extra?.key === 'user_max_attempts') {
                return Alert.warning('Lo sentimos, alcanzó el máximo de intentos de recupero. Por favor contacte al administrador.', 7000);
            }
            if ([404, 400].includes(error.response.status)) {
                return Alert.warning('Las credenciales ingresadas son incorrectas.', 7000);
            }
            Alert.error('Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.', 7000);
        }
        finally {
            setIsLoading(false);
        }
    };

    return (
        <div className='auth-page'>
            <Avatar>
                <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
                Olvide mi contraseña
            </Typography>
            <form noValidate onSubmit={recover}>
                <TextField
                    id="recovery"
                    label="Email"
                    name="account"
                    variant="outlined"
                    fullWidth autoFocus
                    onChange={(event) => setEmail(event.target.value)}
                />
                <Button type="submit" appearance='primary' block variant="contained" disabled={isLoading}>
                    Recuperar contraseña
                </Button>
            </form>
            <Link variant="body2" onClick={toLogin}>
                Volver
            </Link>
        </div>
    );
};

export default injectIntl(connect(null, auth.actions)(Login));
